export const SQUAD = '[SQUAD]'
export const ADD_SQUAD_MEMBERS = `${SQUAD} Add Squad Members`
export const DELETE_SQUAD_MEMBERS = `${SQUAD} Delete Squad Members`

export const addSquadMembers = units => ({
    type: ADD_SQUAD_MEMBERS,
    payload: {
        units,
    },
    meta: {
        persisted: 'squad',
    },
})

export const deleteSquadMembers = units => ({
    type: DELETE_SQUAD_MEMBERS,
    payload: {
        units,
    },
    meta: {
        persisted: 'squad',
    },
})
